<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  data() {
    return {
      cores: [
        'AMARELA',
        'AZUL',
        'BEGE',
        'BRANCA',
        'CINZA',
        'DOURADA',
        'GRENA',
        'LARANAJA',
        'MARROM',
        'PRATA',
        'PRETA',
        'ROSA',
        'ROXA',
        'VERDE',
        'VERMELHA',
        'FANTASIA'
      ],
    }
  },
  computed: { 
    ...mapState({
      alerta: state => state.moduleAlerta.alerta,
    }),
  },
}
</script>

<template>
<div>
  <b-form-text>Cor:</b-form-text>
  <b-form-select v-model="alerta.cor" required :options="cores" :disabled='!ativar'/>
</div>  
</template>

<style>

</style>